import SeoAuditList from './SeoAuditList.container';

export default SeoAuditList;
